export default "__VITE_ASSET__D3muzmJ9__"